export default __webpack_public_path__ + "static/logo-46d80ac3b5dd3c7de9d627140242b381.png";